/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Stock_Out_Shortage_HintInputs */

const vi_stock_out_shortage_hint = /** @type {(inputs: Stock_Out_Shortage_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nhập thêm hàng hoặc sửa đơn trước khi xuất kho.`)
};

/**

* @param {Stock_Out_Shortage_HintInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const stock_out_shortage_hint = /** @type {((inputs?: Stock_Out_Shortage_HintInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Stock_Out_Shortage_HintInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_stock_out_shortage_hint(inputs)
});